import request from '@/utils/request'

let Route_priceApi = {

  /*路线价格列表*/
  list(data) {
    return request._post('/shop/plus.route_price.Index/index', data);
},
/*添加路线价格*/
add(data) {
    return request._post('/shop/plus.route_price.Index/add', data);
},
/*修改路线价格*/
edit(data) {
    return request._post('/shop/plus.route_price.Index/edit', data);
},
/*删除路线价格*/
del(data) {
    return request._post('/shop/plus.route_price.Index/del', data);
},
/*路线价格详情*/
detail(data) {
  return request._post('/shop/plus.route_price.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.route_price.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.route_price.Setting/getSetting', data, errorback);
    },
}
export default Route_priceApi;



// WEBPACK FOOTER //
// ./src/api/route_price.js